import { render, staticRenderFns } from "./ArchiveUserView.vue?vue&type=template&id=4eafc3d5"
import script from "./ArchiveUserView.vue?vue&type=script&lang=js"
export * from "./ArchiveUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports